import { ResourceStatusEnum } from '@/types/schema';

import { QuizEditorDetailsFragment } from '../../graphql/fragments/generated/QuizEditorContent';
import useQuizEditorActions from '../useQuizEditorActions';
import useQuizEditorEffects from '../useQuizEditorEffects';
import useQuizEditorState from '../useQuizEditorState';

interface Params {
  quiz: QuizEditorDetailsFragment;
}

export const QUIZ_PUBLISHED_STATUS = [
  ResourceStatusEnum.Published,
  ResourceStatusEnum.UnpublishedChanges,
];

const useQuizEditor = ({ quiz }: Params) => {
  const isQuizPublished = QUIZ_PUBLISHED_STATUS.includes(quiz.status);
  const canEditSections = quiz.status !== ResourceStatusEnum.Published;

  const state = useQuizEditorState({ quiz, isQuizPublished });
  const { uiState, questions } = state;

  const actions = useQuizEditorActions({ quiz, state, isQuizPublished });

  useQuizEditorEffects({ state, isQuizPublished });

  return {
    uiState,
    quiz,
    questions,
    publishedQuestionById: state.publishedQuestionById,
    isQuizPublished,
    canEditSections,
    ...actions,
  };
};
export default useQuizEditor;
